const commonGetter = {
  getModule(state) {
    return state.module;
  },
  getCourses(state) {
    return state.courses;
  },
  login(state) {
    return state.login;
  },
  getCourseDetails(state) {
    return state.courseDetails;
  },
  getCourseOpenJobs(state) {
    return state.courseOpenJobs;
  },
  getSearchCerts(state) {
    return state.certs;
  },
  getEnterpriseRegistration(state) {
    return state.enterprise;
  },
  getEmployeeDegree(state) {
    return state.employeeDegree;
  },
  getEmployeeTitle(state) {
    return state.employeeTitle;
  },
  getCertClass(state) {
    return state.certClass;
  },
  getCertSubClass(state) {
    return state.certSubClass;
  },
  getCourseJobs(state) {
    return state.jobs;
  },
  getLearnLearnDetails(state) {
    return state.learnDetails;
  },
  getLearnLearnApproveStep(state) {
    return state.learnApproveStep;
  },
  getCommonLearnPayMethod(state) {
    return state.learnPayMethod;
  },
  getCommonMakeUpPayMethod(state) {
    return state.makeUpPayMethod;
  },
  getMakeUpMakeUpDetails(state) {
    return state.makeUpDetails;
  },
  getMakeUpMakeUpApproveStep(state) {
    return state.makeUpApproveStep;
  },
  getNews(state) {
    return state.news;
  },
  getNewsDetails(state) {
    return state.newsDetails;
  },
  getNewsTestPlans(state) {
    return state.newsTestPlans;
  },
  getCourseRecommends(state) {
    return state.courseRecommends;
  },
  getLearnApproveCount1(state) {
    return state.learnApproveCount1;
  },
  getLearnApproveCount2(state) {
    return state.learnApproveCount2;
  },
  getLearnApproveCount3(state) {
    return state.learnApproveCount3;
  },
  getMakeUpApproveCount1(state) {
    return state.makeUpApproveCount1;
  },
  getMakeUpApproveCount2(state) {
    return state.makeUpApproveCount2;
  },
  getMakeUpApproveCount3(state) {
    return state.makeUpApproveCount3;
  },
  getLearningmgtDetails(state) {
    return state.learningmgtDetails;
  },
  getCommonJob(state) {
    return state.commonJob;
  },
  getStudyRecordDetails(state) {
    return state.studyRecordDetails;
  },
  getInvoiceApproveDetails(state) {
    return state.invoiceApproveDetails;
  },
  getQuickComments(state) {
    return state.quickComments;
  },
  getWeiXinTmpQrCode(state) {
    return state.weiXinTmpQrCode;
  }
};

export default commonGetter;



// WEBPACK FOOTER //
// ./src/store/jzjy/getters/commonGetter.js